import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import "./SocialProof.css";

const testimonials = [
  {
    name: "Restaurante Sushi Prime",
    text: "Depois que colocamos as sobremesas, nosso ticket médio aumentou muito.",
  },
  {
    name: "Temaki House",
    text: "Produto fácil de trabalhar e vende sozinho no cardápio.",
  },
  {
    name: "Sushi Bar Concept",
    text: "Os clientes começaram a pedir sobremesa toda vez.",
  },
];

function SocialProof() {
  return (
    <section className="social-proof section">
      <div className="container">
        <SectionTitle
          center
          eyebrow="Prova social"
          title="Restaurantes já estão aumentando o faturamento com sobremesas"
        />

        <div className="social-proof__grid">
          {testimonials.map((item, index) => (
            <div key={index} className="social-proof__card">
              <p>"{item.text}"</p>
              <strong>{item.name}</strong>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SocialProof;